<template>
	<div class="permissionManage mainBox">
		<div class="mainTop disBetween">
			<div class="titleIcon"></div>
			<div class="titleName">权限管理</div>
		</div>
		<div class="mainBot ">
			<div class="itemTitleBox disBetween">
				<div class="disStart">
					<span class="title">角色列表</span>
				</div>
				<div class="icon_add iconBox" @click="itemClick({},5)" title="新增角色"></div>
			</div>
			<div class="BtnBox disBetween">
				<div class="searchBox disBetween">
					<div class="disBetween searchLeft">
						<div class="myinputBox">
							<el-input clearable v-model="searchObj.search" placeholder="请输入角色名">
							</el-input>
							<!-- <el-select clearable v-model="searchObj.communityId" filterable remote reserve-keyword
								placeholder="请输入角色名称" :remote-method="remoteMethod" @change="changeSelect">
								<el-option v-for="item in restaurants" :key="item.communityId"
									:label="item.communityName" :value="item.communityId">
								</el-option>
							</el-select> -->
						</div>
						<el-button type="success" @click="toSearch">查询</el-button>
					</div>
					<el-button type="success" @click="exportData">导出</el-button>
				</div>

			</div>
			<div class="listBox">
				<div style="height: 100%;width: 100%;" v-loading="loading">
					<div class="content myTable">
						<el-table :data="tableData" stripe style="width: 100%">
							<el-table-column type="index" label="序号">
							</el-table-column>
							<el-table-column show-overflow-tooltip prop="roleName" label="角色名称">
							</el-table-column>
							<el-table-column show-overflow-tooltip prop="roleDesc" label="角色描述">
							</el-table-column>
							<el-table-column show-overflow-tooltip prop="roleIndex" label="排序">
							</el-table-column>
							<el-table-column label="操作" width="220">
								<template slot-scope="scope">
									<el-button type="text" size="small" @click="itemClick(scope.row,1)">编辑</el-button>
									<el-button type="text" size="small" @click="itemClick(scope.row,2)">删除</el-button>
									<el-button type="text" size="small" @click="itemClick(scope.row,3)">权限配置</el-button>
								</template>
							</el-table-column>
						</el-table>
					</div>
					<div class="pagination  mypagination">
						<el-pagination background small :page-size="PageInfo.pagesize" :current-page="PageInfo.pagenum"
							:total="PageInfo.total" :pager-count="5" prev-text="上一页" next-text="下一页"
							layout="total, prev, pager, next,jumper" ref="pagination"
							@current-change="handleCurrentChange">
						</el-pagination>
					</div>
				</div>
			</div>
		</div>
		<el-dialog :title="dialogTitle" center class="mydialog" :close-on-click-modal="NOfalse"
			:visible.sync="dialogVisible" width="60%">
			<el-form :model="creatObj" :rules="rules" ref="ruleForm1" label-width="100px" class="demo-ruleForm">
				<div class="dialogBox">
					<div class="diaItem disBetween">
						<div class="diaTpye disStart">
							<el-form-item class="lableBox" label="角色名称" prop="roleName">
								<div class="myinputBox">
									<el-input clearable v-model="creatObj.roleName" placeholder="请输入角色名称">
									</el-input>
								</div>
							</el-form-item>
						</div>
						<div class="diaTpye disStart">
							<el-form-item class="lableBox" label="排序" prop="roleIndex">
								<div class="myinputBox">
									<el-input clearable type="Number" v-model="creatObj.roleIndex" placeholder="请输入排序">
									</el-input>
								</div>
							</el-form-item>
						</div>
					</div>
					<div class="diaItem disBetween">
						<div class="diaTpye disStart">
							<el-form-item class="lableBox" label="角色描述" prop="roleDesc">
								<div class="myinputBox myinputBox4">
									<el-input type="textarea" placeholder="请输入角色描述" v-model="creatObj.roleDesc"
										resize="none">
									</el-input>
								</div>
							</el-form-item>
						</div>

					</div>

				</div>
				<el-form-item class="diabtnBox disCenter">
					<el-button @click="dialogVisible=false">取 消</el-button>
					<el-button type="primary" @click="toSave('ruleForm1')">保 存</el-button>
				</el-form-item>
			</el-form>

		</el-dialog>
		<el-dialog title="权限配置" center class="mydialog" :close-on-click-modal="NOfalse" :visible.sync="dialogDispose"
			width="60%">
			<div class="dialogBox dialogBox2">
				<div class="disposeBox disBetween">
					<div class="disposeLeft">
						<div class="choiceBox">选择模块</div>
						<div class="moduleList">
							<div v-for="(item,inx) in menuList" :key="inx" class="itemBox disStart"
								:class="{active:active==inx}" @click="changeActive(inx)">
								<span class="titleBox">{{item.permissionsModelName}}</span>
								<el-checkbox v-model="item.checkFlag" v-if="item.children.length>0"
									@change="moduleClick($event,item,inx)"></el-checkbox>
							</div>
						</div>
					</div>
					<div class="linBox"></div>
					<div class="disposeRight">
						<div class="choiceBox">{{menuList[active].permissionsModelName}}</div>
						<div class="moduleList" v-loading="loadingBox">
							<div v-for="(item,inx) in menuList[active].children||[]" :key="inx"
								class="itemBox disStart">
								<span class="titleBox">{{item.permissionsModelName}}</span>
								<el-checkbox v-model="item.checkFlag" @change="menuClick($event,item,inx,active)">
								</el-checkbox>
							</div>
							<div v-if="menuList[active].children.length<=0" class="nodataList">
								该模块下暂无菜单
							</div>
						</div>
					</div>
				</div>
				<div slot="footer" class="dialog-footer diabtnBox disAround">
					<el-button @click="dialogDispose = false">取 消</el-button>
					<el-button type="primary" @click="savedialogDispose">确 定</el-button>
				</div>
			</div>
		</el-dialog>
	</div>
</template>
<script type="text/javascript">
	import {
		timestampToDate
	} from "@/assets/js/common.js"
	import {
		menuData
	} from "@/assets/js/data.js"
	export default {
		name: "accountManage",
		components: {},
		data() {
			return {
				PageInfo: {
					pagesize: 10,
					pagenum: 1,
					total: 0
				},
				creatObj: {},
				dialogVisible: false,
				dialogDispose: false,
				NOfalse: false,
				loadingBox: false,
				dialogTitle: "新增角色",
				roleList: [],
				serviceList: [],
				active: 0,
				statusList: [{
						text: "状态1",
						value: 1
					},
					{
						text: "状态2",
						value: 2
					},
					{
						text: "状态3",
						value: 3
					},
				],
				tableData: [],
				loading: false,
				searchObj: {
					communityId: "", //社区编号
					communitySiteId: "",
					communityEquipmentNo: "",
					equipmentStatus: "",
					equipmentRunStatus: "",
					pageNo: 1, //当前页
					pageSize: 10, //当前页个数
					searchData: [],
				},
				restaurants: [],
				options: [],
				menuList: [{
					title: '',
					icon: '',
					children: []
				}],
				areaValue: "",
				rules: {
					roleName: [{
						required: true,
						message: '请输入角色名称',
						trigger: 'blur'
					}],
					roleIndex: [{
						required: true,
						message: '请输入排序',
						trigger: 'blur'
					}],
					roleDesc: [{
						required: true,
						message: '请输入角色描述',
						trigger: 'blur'
					}],

				},
			}
		},
		mounted() {
			this.$nextTick(() => {
				this.getData()
			})
		},
		methods: {
			exportData(){
				let obj={
					search:this.searchObj.search
				}
				this.$api.exportUserRole(obj,"角色列表").then((res)=>{
					if(res.returnCode==200){
						
					}
				})
			},
			// 保存按钮点击事件 新建/编辑
			toSave(formName) {
				let that = this
				this.$refs[formName].validate((valid) => {
					if (valid) {
						if (that.dialogTitle == "新增角色") {
							that.addUserRole()
						} else {
							that.updateUserRole()
						}
					} else {
						return false;
					}
				});

			},
			savedialogDispose() {
				let arr = []
				for (let k of this.menuList) {
					if (k.checkFlag) {
						arr.push(k.permissionsModelId)
					}
					if (k.children) {
						for (let j of k.children) {
							if (j.checkFlag) {
								arr.push(j.permissionsModelId)
							}
						}
					}
				}
				if (arr.length > 0) {
					let obj = {
						roleId: this.creatObj.roleId,
						permissionsModelIdList: arr
					}
					this.$api.bindUserRolePermissions(obj).then((res) => {
						if (res.returnCode == 200) {
							this.$nextTick(() => {
								this.dialogDispose = false
								this.$message({
									message: '编辑权限成功',
									type: 'success'
								});
								setTimeout(() => {
									this.getData()
								}, 500)
							})
						}
					})
				} else {
					this.$message({
						message: '请选择权限',
						type: 'error'
					});
				}
				
			},
			updateUserRole() {
				let obj = {
					id: this.creatObj.id,
					roleId: this.creatObj.roleId,
					adminFlag: this.creatObj.adminFlag,
					roleName: this.creatObj.roleName,
					roleDesc: this.creatObj.roleDesc,
					roleIndex: this.creatObj.roleIndex,
				}
				this.$api.updateUserRole(obj).then((res) => {
					if (res.returnCode == 200) {
						this.$nextTick(() => {
							this.dialogVisible = false
							this.$message({
								message: '编辑角色成功',
								type: 'success'
							});
							setTimeout(() => {
								this.getData()
							}, 500)
						})
					}
				})
			},
			addUserRole() {
				let obj = {
					roleName: this.creatObj.roleName,
					roleDesc: this.creatObj.roleDesc,
					roleIndex: this.creatObj.roleIndex,
				}
				this.$api.addUserRole(obj).then((res) => {
					if (res.returnCode == 200) {
						this.$nextTick(() => {
							this.dialogVisible = false
							this.$message({
								message: '新增角色成功',
								type: 'success'
							});
							setTimeout(() => {
								this.getData()
							}, 500)
						})
					}
				})
			},
			changeActive(inx) {
				if (inx == this.active) {
					return false
				}
				this.loadingBox = true
				for (let k of this.menuList[inx].children) {
					if (k.checkFlag == true) {
						this.$set(k, "checktag", true)
					} else {
						this.$set(k, "checktag", false)
					}
				}
				setTimeout(() => {
					this.$set(this, "active", inx)
					this.loadingBox = false
				}, 200)

			},
			moduleClick(e, item, inx) {
				this.$nextTick(() => {
					for (let k of this.menuList[inx].children) {
						this.$set(k, "checkFlag", e)
					}
				})
			},
			menuClick(e, item, inx, active) {
				this.$nextTick(() => {
					let index = this.menuList[this.active].children.findIndex((res) => {
						return res.checkFlag == true
					})
					if (index != -1) {
						this.$set(this.menuList[this.active], "checkFlag", true)
					} else {
						this.$set(this.menuList[this.active], "checkFlag", false)
					}
				})
			},
			// 编辑1删除2权限配置3新增5
			itemClick(item, n) {
				let that = this
				if (n == 1) {
					this.dialogTitle = "编辑角色"
					this.$set(this, "creatObj", JSON.parse(JSON.stringify(item)))
					this.dialogVisible = true
					this.$nextTick(() => {
						this.$refs.ruleForm1.clearValidate()
						// this.initMap()
					})
				} else if (n == 3) {
					this.$set(this, "creatObj", item)
					this.listPermissionsModelByRoleId(item)
				} else if (n == 5) {
					this.dialogTitle = "新增角色"
					this.$set(this, "creatObj", {
						roleName: "", //角色名
						roleDesc: "", //角色描述
						roleIndex: '', //角色排序

					})
					this.dialogVisible = true
					this.$nextTick(() => {
						this.$refs.ruleForm1.clearValidate()
					})
				} else if (n == 2) {
					this.$confirm('是否确认删除该角色?', '提示', {
						confirmButtonText: '确定',
						cancelButtonText: '取消',
						type: 'warning'
					}).then(() => {
						that.$api.deleteUserRole({
							roleId: item.roleId
						}).then((res) => {
							if (res.returnCode == 200) {
								that.$message({
									type: 'success',
									message: '删除成功!'
								});
								setTimeout(() => {
									that.getData()
								}, 500)
							}
						})

					}).catch(() => {

					});
				}
			},
			listPermissionsModelByRoleId(item) {
				this.$api.listPermissionsModelByRoleId({
					roleId: item.roleId
				}).then((res) => {
					if (res.returnCode == 200) {
						this.$set(this, "menuList", res.obj)
					}
				})
				this.dialogDispose = true
			},
			remoteMethod(query) {
				let that = this
				if (query !== '') {
					let searchObj = {
						search: query,
						pageNo: 1, //当前页
						pageSize: 1000, //当
						provinceCode: "", //省级编号
						cityCode: "", //市级编号
						areaCode: "" //区级编号
					}
					that.$api.listCommunityInfo(searchObj).then((res) => {
						if (res.returnCode == 200) {
							that.$set(that, "restaurants", res.obj.list)
							setTimeout(() => {
								that.options = that.restaurants.filter(item => {
									return item.communityName.toLowerCase()
										.indexOf(query.toLowerCase()) > -1;
								});
							}, 200);

						}
					})

				} else {
					this.options = [];
				}
			},
			changeSelect(n) {
				// this.$set(this, "personList", [])
				// this.$set(this.searchObj, "communitySiteId", "")
				// if (n) {
				// 	this.$api.listAllCommunitySiteByCommunityId({
				// 		communityId: n
				// 	}).then((res) => {
				// 		if (res.returnCode == 200) {
				// 			this.$set(this, "personList", res.obj)
				// 		}
				// 	})
				// }
			},
			getName(val, arr) {
				let obj = arr.find((item) => {
					return val == item.value
				})
				return obj.text
			},
			toSearch() {
				this.searchObj.pageNo = 1
				this.$nextTick(() => {
					this.getData()
				})
			},
			getData(n) {
				this.loading = true
				this.$api.listUserRole(this.searchObj).then((res) => {
					if (res.returnCode == 200) {
						this.loading = false
						this.$set(this, "tableData", res.obj.list || [])
						this.$set(this.PageInfo, "total", res.obj.total || 0)
					}
				})
			},
			// 选择分页
			handleCurrentChange(val) {
				this.searchObj.pageNo = val
				this.getData({})
			},
			handleChange(value, n) {
				let nodesInfo = this.$refs['cascader' + n].getCheckedNodes()
				if (nodesInfo.length > 0) {
					this.$set(this.searchObj, "provinceCode", nodesInfo[0].path[0] || "")
					this.$set(this.searchObj, "cityCode", nodesInfo[0].path[1] || "")
					this.$set(this.searchObj, "areaCode", nodesInfo[0].path[2] || "")
				}
			},
		}
	}
</script>

<style lang="scss" scoped>
	@import "./permissionManage.scss";
</style>